"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableSettingsListContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@dnd-kit/core");
var _sortable = require("@dnd-kit/sortable");
var _modifiers = require("@dnd-kit/modifiers");
var _TableSettingsListItem = _interopRequireDefault(require("./TableSettingsListItem"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable new-cap */
/* eslint-disable no-unused-vars */

var TableSettingsListContainer = function TableSettingsListContainer(props) {
  var items = props.items,
    onSortEnd = props.onSortEnd,
    itemProps = props.itemProps;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    activeDraggedColumn = _useState2[0],
    setActiveDraggedColumn = _useState2[1];
  var sensors = (0, _core.useSensors)((0, _core.useSensor)(_core.PointerSensor), (0, _core.useSensor)(_core.KeyboardSensor, {
    coordinateGetter: _sortable.sortableKeyboardCoordinates
  }));
  var handleDragStart = (0, _react.useCallback)(function (event) {
    setActiveDraggedColumn(event.active.id);
  }, []);
  var handleDragEnd = (0, _react.useCallback)(function (event) {
    setActiveDraggedColumn(null);
    onSortEnd(event);
  }, []);
  var activeClass = 'table-settings-item shadow-smooth-to-bottom z-index-max';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-settings-items-container"
  }, /*#__PURE__*/_react["default"].createElement(_core.DndContext, {
    modifiers: [_modifiers.restrictToVerticalAxis],
    onDragStart: handleDragStart,
    onDragEnd: handleDragEnd
  }, /*#__PURE__*/_react["default"].createElement(_sortable.SortableContext, {
    items: items,
    sensors: sensors,
    collisionDetection: _core.closestCenter,
    strategy: _sortable.rectSortingStrategy
  }, items.map(function (column, index) {
    return /*#__PURE__*/_react["default"].createElement(_TableSettingsListItem["default"], (0, _extends2["default"])({
      key: column,
      index: index,
      column: column,
      orderIndex: index,
      className: activeDraggedColumn === column ? activeClass : ''
    }, itemProps));
  }))));
};
exports.TableSettingsListContainer = TableSettingsListContainer;
TableSettingsListContainer.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].string),
  onSortEnd: _propTypes["default"].func,
  itemProps: _propTypes["default"].object
};